import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/globals.css';
import './i18n/index.js';

import { App } from './App.js';
import { loadEnv } from './lib/env.js';
import { initErrorTracker } from './lib/error-tracker.js';

// Validate env up front — throws `ZodError` with a readable path if anything is missing.
// Failing here is preferable to a cryptic runtime crash deep inside a feature.
loadEnv();
initErrorTracker();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
